import { ARSMODELL_FAKTA, getArsmodellFakta, type ArsmodellFakta } from "./husbil-arsmodell-fakta";

// Datakällor för /husbil-till-salu-under-[pris] och /husbil-arsmodell-[år]

export const PRIS_TIERS = [
  {
    slug: "300000",
    max: 300000,
    label: "300 000",
    intro:
      "Husbil under 300 000 kr är budget-segmentet — oftast äldre plåthusbilar (2005–2012), husvagnar med god kondition, eller enkla halvintegrerade från 2003–2008. Rätt val för dig som vill komma igång utan att låna.",
    what: "Vad du får för pengarna",
    reality:
      "Räkna med 15–20 år gammal husbil, ofta med 15 000–25 000 mil. Vissa slitagepunkter (kylskåp, taksäng, batteri) kan behöva bytas snart. Fuktkontroll är kritisk — kräv färsk fuktprotokoll.",
    goodFor: [
      "Förstagångsköpare som vill testa livsstilen",
      "Helgcamping i Sverige/Norge/Danmark",
      "Kunder som vill undvika lån och äga bilen kontant",
    ],
    avoid: [
      "Långresor (2+ månader) — bilar från 2005–2010 saknar moderna bekvämligheter",
      "Vinterbruk under -10 °C utan omfattande efterisolering",
    ],
    typical: "Adria Adiva 2006, Bürstner Fun 2008, Hobby Van 2005–2010",
  },
  {
    slug: "400000",
    max: 400000,
    label: "400 000",
    intro:
      "Under 400 000 kr öppnas upp för nyare plåthusbilar (2010–2014) och välskötta halvintegrerade från 2008–2012. Fortfarande budget men med moderna bekvämligheter.",
    what: "Vad du får för pengarna",
    reality:
      "Vanligen 10–15 år gammal, 10 000–20 000 mil. Chassit har långt kvar; det är boende­delen som avgör värdet. Kolla noga att fuktvärden i väggar är under 15%.",
    goodFor: [
      "Par som vill ha modern husbil till budgetpris",
      "Långhelger och 2–4 veckors semestrar",
      "Wildcamping i norr under sommar-/höstsäsong",
    ],
    avoid: ["Året-runt-boende", "Vinterresor i Norrland utan uppgradering"],
    typical: "Bürstner Ixeo 2010, Pilote Van 2011, Adria Twin 2010–2013",
  },
  {
    slug: "500000",
    max: 500000,
    label: "500 000",
    intro:
      "500 000 kr är den vanligaste 'första riktiga husbils­budgeten' — nyare plåthusbilar (2013–2017) eller premium­halvintegrerade från 2010–2014.",
    what: "Vad du får för pengarna",
    reality:
      "Här börjar det se ut som moderna husbilar — solpaneler, LED, kompressorkyl, ibland litium. 8–12 år gammal, 8 000–15 000 mil.",
    goodFor: [
      "Par som planerar 1–3 månaders resor per år",
      "Familj med små barn för sommarcamping",
      "Byte upp från husvagn",
    ],
    avoid: ["Året-runt-boende utan efterinvestering i sol/litium"],
    typical: "Rapido V55 2014, Adria Twin 2015, Hymer Van 2014, Bürstner Ixeo 2013",
  },
  {
    slug: "600000",
    max: 600000,
    label: "600 000",
    intro:
      "Under 600 000 kr får du välskötta 5–10 år gamla premium­plåthusbilar eller halvintegrerade från 2012–2016. Sweet spot för valuta.",
    what: "Vad du får för pengarna",
    reality:
      "Nya nog för moderna bekvämligheter, gamla nog att första värdeminskning­sdippen är över. 6–10 år gammal, 5 000–12 000 mil.",
    goodFor: [
      "Par som vill ha 'riktig' husbil för långresor",
      "Kunder som vill undvika ny-bil-dippen",
      "Vinter­resenärer om modellen har dubbla golv",
    ],
    avoid: ["Ingen — utmärkt prisklass för de flesta"],
    typical: "Rapido V62 2015, Hymer B-Class 2013, Bürstner Delfin 2014",
  },
  {
    slug: "800000",
    max: 800000,
    label: "800 000",
    intro:
      "800 000 kr köper 3–7 år gamla premium­husbilar — Rapido V-serien i toppskick, Hymer premium, mindre halvintegrerade i årsmodell 2018–2021.",
    what: "Vad du får för pengarna",
    reality:
      "Modern teknik: litium tillgängligt, kompressorkyl, dieselvärme, solpaneler. 3–7 år gammal, 3 000–8 000 mil.",
    goodFor: [
      "Långresenärer 3–6 månader per år",
      "Vinter­nomader i Norrland/Norge",
      "Kunder som byter från äldre husbil upp",
    ],
    avoid: ["Ingen — premium­segment till bra pris"],
    typical: "Rapido V62 2020, Rapido V68 2019, Hymer B-MC 2018",
  },
  {
    slug: "1000000",
    max: 1000000,
    label: "1 000 000",
    intro:
      "Under 1 miljon kr får du 2–5 år gamla premium­plåthusbilar i toppskick eller nya entry-nivå från 2024–2025. Också ingången till halvintegrerade premium.",
    what: "Vad du får för pengarna",
    reality:
      "Allt du kan begära av modern husbil: litium standard eller nästan, solpaneler, dieselvärme, kompressorkyl. 2–5 år gammal, 1 500–6 000 mil.",
    goodFor: [
      "Året-runt-boende",
      "Digitala nomader",
      "Kunder som prioriterar bygg­kvalitet över storlek",
    ],
    avoid: ["Ingen"],
    typical: "Rapido V62 2022, Rapido 866F 2019, Ny Adria/Bürstner entry 2024",
  },
];

export const AR_MODELLER = [
  { slug: "2018", year: 2018, ageYears: 8 },
  { slug: "2019", year: 2019, ageYears: 7 },
  { slug: "2020", year: 2020, ageYears: 6 },
  { slug: "2021", year: 2021, ageYears: 5 },
  { slug: "2022", year: 2022, ageYears: 4 },
  { slug: "2023", year: 2023, ageYears: 3 },
  { slug: "2024", year: 2024, ageYears: 2 },
  { slug: "2025", year: 2025, ageYears: 1 },
  { slug: "2026", year: 2026, ageYears: 0 },
] as const;

export const PRIS_TIER_SLUGS = PRIS_TIERS.map((p) => p.slug);
export const AR_SLUGS = AR_MODELLER.map((a) => a.slug);

export function getPrisTier(slug: string) {
  return PRIS_TIERS.find((p) => p.slug === slug);
}
export function getArModell(slug: string) {
  return AR_MODELLER.find((a) => a.slug === slug);
}

// Fakta per årsmodell — nu årsspecifika (se husbil-arsmodell-fakta.ts).
// Tidigare returnerade denna funktion samma text för flera årtal, vilket gav
// dubblettinnehåll mellan sidorna. Den delegerar nu till en källa med unika
// fakta per modellår.
export function getYearContext(year: number): ArsmodellFakta {
  const exact = getArsmodellFakta(year);
  if (exact) return exact;
  // Fallback: närmaste kända årsmodell (ska normalt aldrig behövas eftersom
  // AR_MODELLER och ARSMODELL_FAKTA täcker samma år).
  return ARSMODELL_FAKTA.reduce((best, a) =>
    Math.abs(a.year - year) < Math.abs(best.year - year) ? a : best,
  );
}
